export class IncentiveCockpitAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The market-local day's committed spend per envelope, hour by hour, against the controller's pacing plan (`incentive_lever:view`). */
    spend(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/incentive-cockpit/spend?${new URLSearchParams({ market: marketId }).toString()}`, auth: true });
    }
    /** The newest controller decision of each zone and the offers in force in it (`incentive_lever:view`). */
    zones(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/incentive-cockpit/zones?${new URLSearchParams({ market: marketId }).toString()}`, auth: true });
    }
    /** D841: the surge-retention policy state and each zone's retention in force (`incentive_lever:view`). A server without it answers 404: `available: false`. */
    async surgeRetention(marketId) {
        const res = await this.client.request({
            method: 'GET', path: `/v1/admin/incentive-cockpit/surge-retention?${new URLSearchParams({ market: marketId }).toString()}`, auth: true,
        });
        if (res.ok)
            return { ok: true, value: { available: true, ...res.value } };
        if (res.error.code === 'NOT_FOUND')
            return { ok: true, value: { available: false, reason: 'SURGE_RETENTION_NOT_COMPOSED', marketId } };
        return res;
    }
    /** The controller policy in force for the market, whole (`incentive_lever:view`). */
    policy(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/incentive-cockpit/policy?${new URLSearchParams({ market: marketId }).toString()}`, auth: true });
    }
    /**
     * What each lever cost and returned on a finished market-local day (`YYYY-MM-DD`) and where the automatic shutdown stands - D496's own read route (`incentive_lever:view`). A server without
     * the measurement answers 404: that is `available: false` / `MEASUREMENT_NOT_WIRED` here, never an error and never a number.
     */
    async results(marketId, day) {
        const res = await this.client.request({
            method: 'GET',
            path: `/v1/admin/incentive-measurement?${new URLSearchParams({ market: marketId, day }).toString()}`,
            auth: true,
        });
        if (res.ok)
            return { ok: true, value: { available: true, ...res.value } };
        if (res.error.code === 'NOT_FOUND')
            return { ok: true, value: { available: false, reason: 'MEASUREMENT_NOT_WIRED', marketId, day } };
        return res;
    }
    /** READ-ONLY: what a draft policy (and the one in force) would have made of yesterday's windows. Nothing is saved or sent (`incentive_lever:view`). */
    preview(marketId, value) {
        return this.client.request({ method: 'POST', path: '/v1/admin/incentive-cockpit/preview', body: { market: marketId, value }, auth: true });
    }
}
//# sourceMappingURL=incentive-cockpit.js.map